import layout from '@/views/common/layout'
const indexPageChild = [
    {
        path: '/addGoods',
        component: () => import('@/views/goods/editGoods'),
        name: 'editGoodsDetail',
        meta: { title: '编辑商品详情', icon: '', affix: true }
    },
    {
        path: '/editCategory',
        component: () => import('@/views/goods/categoryAttrList'),
        name: 'editCategory',
        meta: { title: '分类维护', icon: '', affix: true }
    },
]

export default indexPageChild


// WEBPACK FOOTER //
// ./src/router/modules/goods.js